import { render, staticRenderFns } from "./BasicSpinner.vue?vue&type=template&id=1b7472fe&scoped=true&"
import script from "./BasicSpinner.vue?vue&type=script&lang=js&"
export * from "./BasicSpinner.vue?vue&type=script&lang=js&"
import style0 from "./BasicSpinner.vue?vue&type=style&index=0&id=1b7472fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7472fe",
  null
  
)

component.options.__file = "BasicSpinner.vue"
export default component.exports